import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';

import { T2B } from './Text';

import TwitterIcon from './Social/TwitterShare';
import FacebookIcon from './Social/FacebookShare';
import LinkedInIcon from './Social/LinkedInShare';

import { media } from '../styles/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  @media (min-width: ${media.tabletPortrait}) {
    padding-bottom: 3rem;
  }

  > div {
    margin-top: 1.5rem;
  }

  a {
    margin-right: 2rem;
  }
`;

class Share extends Component {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string
  };

  handleClick = (e, url) => {
    e.preventDefault();
    window.open(
      url,
      'targetWindow',
      'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=550,height=450'
    );
    return false;
  };

  render() {
    const { pathname, title, summary } = this.props;
    return (
      <StaticQuery
        query={ShareQuery}
        render={data => {
          const url = `${data.site.siteMetadata.siteUrl}${pathname}`;
          const twitterUrl = `http://twitter.com/share?text=${title}&url=${url}&via=smallplanetapps`;
          const facebookUrl = `http://www.facebook.com/sharer/sharer.php?u=${url}`;
          const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}${
            summary ? summary : ''
          }&source=${data.site.siteMetadata.siteUrl}`;

          return (
            <Container>
              <T2B>Share</T2B>
              <div>
                <a
                  onClick={e => this.handleClick(e, twitterUrl)}
                  href={twitterUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Share this post on Twitter"
                >
                  <TwitterIcon />
                </a>
                <a
                  onClick={e => this.handleClick(e, facebookUrl)}
                  href={facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Share this post on Facebook"
                >
                  <FacebookIcon />
                </a>
                <a
                  onClick={e => this.handleClick(e, linkedInUrl)}
                  href={linkedInUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Share this post on LinkedIn"
                >
                  <LinkedInIcon />
                </a>
              </div>
            </Container>
          );
        }}
      />
    );
  }
}

export default Share;

const ShareQuery = graphql`
  query DefaultShareQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;
